import { render, staticRenderFns } from "./AppBibleOpen.vue?vue&type=template&id=d859d594&"
import script from "./AppBibleOpen.vue?vue&type=script&lang=js&"
export * from "./AppBibleOpen.vue?vue&type=script&lang=js&"
import style0 from "./AppBibleOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports